import type { SearchCreditOverview } from '@retro-ui/api-contract';
import { isEqual } from 'lodash';
import React from 'react';

import { apiClient } from '@f/api-client';

import { CreditOverviewContext } from './CreditOverviewContext';

type CreditOverviewProviderProps = {
  children: React.ReactNode;
};

async function fetchCreditOverview() {
  const { status, body } = await apiClient.search.fetchCreditOverview();

  if (status !== 200) {
    throw body;
  }

  return body;
}

export function CreditOverviewProvider(props: CreditOverviewProviderProps) {
  const { children } = props;

  const [creditOverview, setCreditOverview] = React.useState<SearchCreditOverview>();

  const updateCreditOverview = async () => {
    const newCreditOverview = await fetchCreditOverview();
    if (!isEqual(newCreditOverview, creditOverview)) {
      setCreditOverview(newCreditOverview);
    }
  };

  return (
    <CreditOverviewContext.Provider value={{ creditOverview, updateCreditOverview }}>
      {children}
    </CreditOverviewContext.Provider>
  );
}
